export default import.meta.ROLLUP_FILE_URL_P4DPfwIRieI8P6q8r4JZRw;